module.exports = __webpack_public_path__ + "img/target.fc13ed49.png";